import apiClient from './apiClient';

export interface InventoryCategoryResponse {
    id: string;
    name: string;
    description?: string;
    color?: string;
    icon?: string;
    isActive: boolean;
}

export interface InventoryCategoryCreateRequest {
    salonId: string;
    name: string;
    description?: string;
    color?: string;
    icon?: string;
}

export interface InventoryCategoryUpdateRequest {
    name?: string;
    description?: string;
    color?: string;
    icon?: string;
}

export const inventoryCategoryApi = {
    /**
     * Get all categories for a salon
     */
    getSalonCategories: async (salonId: string): Promise<InventoryCategoryResponse[]> => {
        const response = await apiClient.get<InventoryCategoryResponse[]>(`/inventory/categories/salon/${salonId}`);
        return response.data;
    },

    /**
     * Create a new category
     */
    createCategory: async (request: InventoryCategoryCreateRequest): Promise<InventoryCategoryResponse> => {
        const response = await apiClient.post<InventoryCategoryResponse>('/inventory/categories', request);
        return response.data;
    },

    /**
     * Update a category
     */
    updateCategory: async (id: string, request: InventoryCategoryUpdateRequest): Promise<InventoryCategoryResponse> => {
        const response = await apiClient.put<InventoryCategoryResponse>(`/inventory/categories/${id}`, request);
        return response.data;
    },

    /**
     * Delete a category
     */
    deleteCategory: async (id: string): Promise<void> => {
        await apiClient.delete(`/inventory/categories/${id}`);
    }
};

export default inventoryCategoryApi;
